import { Grid, User, Circle, Users } from 'react-feather'

export default [
  {
    id: 'users',
    title: 'Users',
    icon: <User size={20} />,
    resource: 'User',
    children: [
      {
        id: 'admin-users',
        title: 'Admin Users',
        icon: <Circle size={12} />,
        navLink: '/user/list',
        resource: 'User'
      },
      {
        id: 'mrsta-users',
        title: 'MRSTA Users',
        icon: <Users size={12} />,
        navLink: '/mrsta-user/list',
        resource: 'User'
      }
    ]
  }
]
